export default "__VITE_ASSET__B2CC9mU7__"